/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_File_Downloaded_SuccessInputs */

const en_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle file downloaded successfully`)
};

const fr_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier de sous-titres téléchargé avec succès`)
};

const de_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteldatei erfolgreich heruntergeladen`)
};

const it_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File dei sottotitoli scaricato correttamente`)
};

const ru_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл субтитров успешно загружен.`)
};

const es_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo de subtítulos descargado exitosamente`)
};

const zh_cn2_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕文件下载成功`)
};

const ja_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕ファイルが正常にダウンロードされました`)
};

const hi_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबटाइटल फ़ाइल सफलतापूर्वक डाउनलोड हो गई`)
};

const pt_pt2_subtitle_file_downloaded_success = /** @type {(inputs: Subtitle_File_Downloaded_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de legenda baixado com sucesso`)
};

/**
* | output |
* | --- |
* | "Subtitle file downloaded successfully" |
*
* @param {Subtitle_File_Downloaded_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_file_downloaded_success = /** @type {((inputs?: Subtitle_File_Downloaded_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_File_Downloaded_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_file_downloaded_success(inputs)
	if (locale === "de") return de_subtitle_file_downloaded_success(inputs)
	if (locale === "it") return it_subtitle_file_downloaded_success(inputs)
	if (locale === "ru") return ru_subtitle_file_downloaded_success(inputs)
	if (locale === "es") return es_subtitle_file_downloaded_success(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_file_downloaded_success(inputs)
	if (locale === "ja") return ja_subtitle_file_downloaded_success(inputs)
	if (locale === "hi") return hi_subtitle_file_downloaded_success(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_file_downloaded_success(inputs)
	return en_subtitle_file_downloaded_success(inputs)
});